import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    entryUrl:'',
  },
  mutations: {
    SET_ENTRY_URL(state, value) {
      state.entryUrl = value;
    }
  },
  actions: {
    setUserInfo({ commit }, info) {
      commit('SET_USER_INFO', info)
    },
    setEntryUrl({ commit }, info) {
      commit('SET_ENTRY_URL', info)
    }

  },
  modules: {
  }
}) 


// WEBPACK FOOTER //
// ./src/store/index.js